module.exports = __webpack_public_path__ + "9788f41e/img/document.e2130c6b.svg";